import i18next from 'i18next';
import ukTranslations from './locales/uk.json'

i18next
    .init({
        lng: 'uk',
        debug: true,
        fallbackLng: 'uk',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            uk: {
                translation: ukTranslations
            }
        }
    });

function translate(key) {
    return i18next.t(key)
}

export default translate